import type { SaveData, UpgradeId } from '../types';

export interface UpgradeEffects {
  movementMultiplier: number;
  orderDuration: number;
  cleanupDuration: number;
  coffeePrepMultiplier: number;
  patienceBonus: number;
  helperSpeedMultiplier: number;
  helperCooldown: number;
}

export class UpgradeSystem {
  static effects(upgrades: SaveData['upgrades']): UpgradeEffects {
    const level = (id: UpgradeId): number => upgrades[id] ?? 0;
    return {
      movementMultiplier: 1 + level('yasemin_speed') * 0.05,
      orderDuration: 0.48 * (1 - level('order_speed') * 0.1),
      cleanupDuration: 0.65 * (1 - level('cleanup_speed') * 0.11),
      coffeePrepMultiplier: 1 - level('coffee_speed') * 0.08,
      patienceBonus: level('patience_bonus') * 5,
      helperSpeedMultiplier: 1 + level('fevzi_speed') * 0.08,
      helperCooldown: Math.max(4.5, 10 - level('fevzi_cooldown') * 1.1),
    };
  }
}
